<template>
  <div>
    <center class="loading-medium" v-if="loading">
      <loading></loading>
    </center>
    <div class="content content-new" v-if="!loading">
      <div class="container-fluid">
        <div
          v-if="!(errorMessage == '' || errorMessage == null)"
          class="alert alert-danger text-center custom-width alert-custom"
        >
          <strong>{{ errorMessage }}</strong>
        </div>
        <div v-else>
          <div class="row" style="margin-bottom: 10px">
            <div class="col-xs-3">
              <h3>Bank Commodities</h3>
            </div>
            <div class="col-xs-6"></div>
            <div class="col-xs-3">
              <img
                :src="BankLogo"
                style="
                  height: 44px;
                  width: 195px;
                  float: right;
                  margin-left: 20px;
                "
              />
            </div>
          </div>
          <div class="form-group form-inline custom-width">
            <input
              type="search"
              class="form-control search-box"
              style="background-color: white"
              placeholder="Search"
              v-model="Search"
            />
            <button
              class="btn btn-primary"
              @click="ChangePageSizeORSearch"
              style="margin-left: 4px"
            >
              Search
            </button>
            <button
              class="btn btn-primary"
              @click="ExportCSV"
              style="margin-left: 4px"
            >
              Export to CSV
            </button>
            <button
              class="btn btn-primary"
              style="margin-left: 4px"
              @click="Print"
            >
              Print
            </button>
            <div class="pull-right">
              <button class="btn btn-primary" @click="AddBankCommodity">
                Add Commodity
              </button>
            </div>
          </div>
          <div v-bind:id="'printable'">
            <strong v-currentdate></strong>

            <table class="table table-bordered ng-grid">
              <thead style="background: #efeeed">
                <tr>
                  <th>No.</th>
                  <th>
                    <a href="javascript:void(0)" @click="ChangeOrder('Code')"
                      >Code</a
                    >
                    <span
                      class="sortorder"
                      v-show="currentSort == 'Code'"
                      :class="{ reverse: curentSortOrder == 'desc' }"
                    ></span>
                  </th>
                  <th>
                    <a href="javascript:void(0)" @click="ChangeOrder('Name')"
                      >Name</a
                    >
                    <span
                      class="sortorder"
                      v-show="currentSort == 'Name'"
                      :class="{ reverse: curentSortOrder == 'desc' }"
                    ></span>
                  </th>
                  <th>
                    <a href="javascript:void(0)" @click="ChangeOrder('Unit')"
                      >Unit</a
                    >
                    <span
                      class="sortorder"
                      v-show="currentSort == 'Unit'"
                      :class="{ reverse: curentSortOrder == 'desc' }"
                    ></span>
                  </th>
                  <th>
                    <a
                      href="javascript:void(0)"
                      @click="ChangeOrder('Supplier')"
                      >Supplier</a
                    >
                    <span
                      class="sortorder"
                      v-show="currentSort == 'Supplier'"
                      :class="{ reverse: curentSortOrder == 'desc' }"
                    ></span>
                  </th>
                  <th>
                    <a
                      href="javascript:void(0)"
                      @click="ChangeOrder('Purchaser')"
                      >Purchaser</a
                    >
                    <span
                      class="sortorder"
                      v-show="currentSort == 'Purchaser'"
                      :class="{ reverse: curentSortOrder == 'desc' }"
                    ></span>
                  </th>
                  <th class="Print">Action</th>
                </tr>
              </thead>
              <tbody>
                <tr
                  v-for="(option, index) in OrderBy"
                  :key="index"
                  :class="{ even: index + (1 % 2) == 0 }"
                >
                  <td>
                    {{
                      (SelectedPageSize == "ALL" ? 0 : SelectedPageSize) *
                        (currentPage - 1) +
                      (index + 1)
                    }}
                  </td>
                  <td>{{ option.Code }}</td>
                  <td>{{ option.Name }}</td>
                  <td>{{ option.Unit }}</td>
                  <td>{{ option.Supplier }}</td>
                  <td>{{ option.Purchaser }}</td>
                  <td class="img Print">
                    <a
                      href="javascript:void(0)"
                      title="Edit User"
                      @click="EditbankCommodity(option.Id)"
                    >
                      <img src="../../assets/imgs/png/Action.png" />
                    </a>
                  </td>
                </tr>
              </tbody>
            </table>
          </div>
          <div class="custom-width">
            <div class="pull-left">
              <paginate
                ref="paginate"
                :page-count="PageCalculation"
                :prev-text="'Prev'"
                :next-text="'Next'"
                :click-handler="clickCallback"
                :container-class="'pagination'"
              ></paginate>
            </div>
            <div class="btn-group form-inline pull-right pager">
              <label>Page Size :</label>
              <select
                v-model="SelectedPageSize"
                class="form-control input-sm"
                @change="ChangePageSizeORSearch"
              >
                <option v-for="(option, index) in PageSize" :key="index">
                  {{ option.key }}
                </option>
              </select>
            </div>
          </div>
          <pre class="custom-width">
Page:{{ currentPage }} / {{ PageCalculation }} </pre
          >
        </div>
      </div>
    </div>
    <addbankcommodity
      v-if="showModal"
      @Close="CloseModal"
      :BankCommodityId="BankCommodityId"
    ></addbankcommodity>
  </div>
</template>



<script>
import * as ACTIONS from "../../store/actions";
import { mapGetters, mapState } from "vuex";
import addbankcommodity from "./AddBankCommodity";
export default {
  data() {
    return {
      SelectedPageSize: 10,
      currentPage: 1,
      showModal: false,
      BankCommodityId: null,
      Search: null,
      currentSort: "Name",
      curentSortOrder: "asc",
    };
  },
  components: {
    addbankcommodity,
  },
  methods: {
    ChangeOrder(key) {
      if (key == this.currentSort) {
        this.curentSortOrder = this.curentSortOrder == "asc" ? "desc" : "asc";
      } else {
        this.curentSortOrder = "asc";
      }
      this.currentSort = key;
      this.ChnageUrl();
    },
    clickCallback: function (page) {
      if (page) {
        this.currentPage = page;
        this.ChnageUrl();
        this.GetData();
      }
    },
    CloseModal() {
      this.showModal = false;
      this.BankCommodityId = null;
      this.GetData();
    },
    EditbankCommodity(id) {
      this.BankCommodityId = id;
      this.showModal = true;
    },
    ChnageUrl() {
      var Url =
        "?page=" +
        this.currentPage +
        "&pagesize=" +
        (this.SelectedPageSize == "ALL" ? "0" : this.SelectedPageSize) +
        "&search=" +
        (this.Search == null ? "" : this.Search) +
        "&dir=" +
        this.curentSortOrder +
        "&sort=" +
        this.currentSort;
      this.$router.push({ path: "" + Url });
    },
    ChangePageSizeORSearch() {
      this.currentPage = 1;
      this.ChnageUrl();
      this.GetData();
    },

    Print() {
      this.printData("printable", "Bank Commodities");
    },
    AddBankCommodity() {
      this.showModal = true;
    },
    GetData() {
      var Url =
        "?currentpage=" +
        this.currentPage +
        "&pagesize=" +
        (this.SelectedPageSize == "ALL" ? "0" : this.SelectedPageSize) +
        "&search=" +
        (this.Search == null ? "" : this.Search);

      var vm = this;
      this.$store
        .dispatch(ACTIONS.BANK_COMMODITIES_GETALL, Url)
        .then((res) => {
          this.$refs.paginate.selected = vm.currentPage - 1;
        })
        .catch((err) => {});
    },
    ExportCSV() {
      this.ObjectToCSV("BankCommoties.csv", this.BANKCOMMODITIES, [
        "Code",
        "Name",
        "Unit",
        "Supplier",
        "Purchaser",
      ]);
    },
  },
  beforeMount() {
    if (this.$route.query) {
      if (this.$route.query.hasOwnProperty("pagesize")) {
        this.SelectedPageSize = this.$route.query["pagesize"];
      }
      if (this.$route.query.hasOwnProperty("search")) {
        this.Search = this.$route.query["search"];
      }
      if (this.$route.query.hasOwnProperty("page")) {
        this.currentPage = this.$route.query["page"];
      }

      if (this.$route.query.hasOwnProperty("sort")) {
        this.currentSort = this.$route.query["sort"];
      }
      if (this.$route.query.hasOwnProperty("dir")) {
        this.curentSortOrder = this.$route.query["dir"];
      }
    }

    this.GetData();
  },
  computed: {
    ...mapGetters({
      PageSize: "PageSize",
      BANKCOMMODITIES: "GETBANKCOMMODITIES",
      TotalRecords: "GETBANKCOMMODITIESTOTALRECORDS",
      errorMessage: "GETBANKCOMMODITYERRORMESSAGE",
      loading: "GETBANKCOMMODITYLOADING",
      BankLogo: "GETBANKLOGO",
    }),
    OrderBy() {
      var data = [...this.BANKCOMMODITIES];
      var SortedArray = this.Sort(data, this.currentSort, this.curentSortOrder);
      if (!this.SelectedPageSize || this.SelectedPageSize == "ALL") {
        this.SelectedPageSize = SortedArray.length;
      }
      if (!this.currentPage) {
        this.currentPage = 1;
      }
      var sp = parseInt(this.SelectedPageSize); // selected Page
      var cp = parseInt(this.currentPage); // current page
      return this.Pagination(SortedArray, sp, cp);
    },
    PageCalculation() {
      var count = Math.ceil(this.TotalRecords / this.SelectedPageSize);
      return count > 0 ? count : 1;
    },
  },
};
</script>